var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page-content',[_c('app-title',{attrs:{"text":"Tareas Resueltas"}}),_vm._v(" "),_c('app-resolved-tasks-filters',{on:{"filter":_vm.onFilter}}),_vm._v(" "),_c('app-resolved-tasks-list',{attrs:{"data":_vm.data},on:{"change-page":_vm.changePage,"sort":_vm.onSort}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }